<ng-container *ngIf="_isVisible">
  <div class="mx-2 mt-2 pb-3 top-wrapper">
    <div class="d-flex justify-content-between">
      <h3>Commands</h3>
      <button
        nf-icon-button="secondary"
        icon="close"
        class="btn-bare close"
        ngbTooltip="Close Commands Drawer"
        (click)="closePanel.emit()"
      >
        Close Commands Drawer
      </button>
    </div>
    <div class="panel-section">
      <div class="button-group">
        <div ngbDropdown container="body">
          <button
            ngbDropdownToggle
            type="button"
            nf-button="primary"
            id="run-with-etls"
            class="dropdown-item btn btn-link run-btn"
            [loading]="isSubmitting"
            [disabled]="totalCommands === 0"
          >
            Submit and send to ETL(s)
          </button>
          <div ngbDropdownMenu aria-labelledby="run-with-etls">
            <button
              type="button"
              class="dropdown-item btn btn-link"
              (click)="runCommands(true, 'CUSTODY')"
            >
              Run All Accounts
            </button>
            <div class="dropdown-divider"></div>
            <button
              type="button"
              class="dropdown-item btn btn-link"
              *ngFor="let accountCommands of commandsByAccountId | keyvalue"
              (click)="runCommands(true, 'CUSTODY', accountCommands.key)"
            >
              Run Account {{ accountCommands.key }}
            </button>
          </div>
        </div>
        <div ngbDropdown class="run-without-etl-btn" container="body">
          <button
            ngbDropdownToggle
            type="button"
            nf-button="primary"
            id="run-without-etls"
            class="dropdown-item btn btn-link run-btn"
            [loading]="isSubmitting"
            [disabled]="totalCommands === 0"
          >
            Submit without ETL(s)
          </button>
          <div ngbDropdownMenu aria-labelledby="run-without-etls">
            <button
              type="button"
              class="dropdown-item btn btn-link"
              (click)="runCommands(false, 'CUSTODY')"
            >
              Run All Accounts
            </button>
            <div class="dropdown-divider"></div>
            <button
              type="button"
              class="dropdown-item btn btn-link"
              *ngFor="let accountCommands of commandsByAccountId | keyvalue"
              (click)="runCommands(false, 'CUSTODY', accountCommands.key)"
            >
              Run Account {{ accountCommands.key }}
            </button>
          </div>
        </div>
        <div ngbDropdown class="run-with-trading-etl-btn" container="body">
          <button
            ngbDropdownToggle
            type="button"
            nf-button="primary"
            id="run-with-trading-etls"
            class="dropdown-item btn btn-link run-btn"
            [loading]="isSubmitting"
            [disabled]="totalCommands === 0"
          >
            Submit and send to Trading ETL(s)
          </button>
          <div ngbDropdownMenu aria-labelledby="run-with-trading-etls">
            <button
              type="button"
              class="dropdown-item btn btn-link"
              (click)="runCommands(true, 'TRADING')"
            >
              Run All Accounts
            </button>
            <div class="dropdown-divider"></div>
            <button
              type="button"
              class="dropdown-item btn btn-link"
              *ngFor="let accountCommands of commandsByAccountId | keyvalue"
              (click)="runCommands(true, 'TRADING', accountCommands.key)"
            >
              Run Account {{ accountCommands.key }}
            </button>
          </div>
        </div>
      </div>
      <div class="commands-section">
        <div class="card-section">
          <h5 class="mb-0">Unsubmitted</h5>
          <div
            *ngFor="let accountCommands of commandsByAccountId | keyvalue"
            class="account-commands"
          >
            <h5 class="mb-0">Account {{ accountCommands.key }}</h5>
            <hs-command-card
              *ngFor="let command of accountCommands.value"
              [command]="command"
            ></hs-command-card>
          </div>
          <p class="small mb-0" *ngIf="totalCommands === 0">No unsubmitted</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
